import React, { useState } from "react";
import { FiAlertTriangle, FiX } from "react-icons/fi";
import { useAuth } from "../../hooks/useAuth";
import ZmianaHaslaOkno from "./ZmianaHaslaOkno";
import styles from "./BanerWygasaniaHasla.module.css";

const KLUCZ_UKRYCIA = "banerHasla.ukryty";

const czytajUkrycie = () => {
    try { return sessionStorage.getItem(KLUCZ_UKRYCIA); } catch { return null; }
};

/** Zdanie banera dla liczby dni (0 = dziś). */
export const tekstBanera = (dni) => {
    if (dni <= 0) return "Twoje hasło do aplikacji wygasa dziś.";
    if (dni === 1) return "Twoje hasło do aplikacji wygasa jutro.";
    return `Twoje hasło do aplikacji wygasa za ${dni} dni.`;
};

/**
 * [HASLA-LOKALNE, decyzja właściciela 2026-09-27] BANER „HASŁO WYGASA ZA N DNI” — konto lokalne, ostatni tydzień ważności
 * (serwer podaje `dniDoWygasnieciaHasla` przy logowaniu i w /users/me tylko wtedy). Przycisk otwiera okno zmiany hasła;
 * „✕” chowa baner do końca sesji karty. Po terminie baneru nie ma — wtedy aplikacja prowadzi już na ekran zmiany hasła.
 *
 * „przypomnienie dla tych co sa lokalnie, ze haslo maja zmienic co 45 dni”.
 */
const BanerWygasaniaHasla = () => {
    const { user, refreshSession } = useAuth() || {};
    const dni = user?.dniDoWygasnieciaHasla;
    const [ukryty, setUkryty] = useState(() => czytajUkrycie() === String(dni));
    const [okno, setOkno] = useState(false);

    // [HASLA-O365 2026-09-28] Baner WYŁĄCZNIE dla konta lokalnego (pole serwera, fail-closed) — konto Office 365 nie dostaje
    // żadnej opcji hasła, nawet gdyby w sesji zostały dni ważności ze starszej odpowiedzi.
    if (user?.kontoLokalne !== true || typeof dni !== "number" || user?.hasloDoZmiany === true || ukryty) return null;

    const ukryj = () => {
        try { sessionStorage.setItem(KLUCZ_UKRYCIA, String(dni)); } catch { /* bez pamięci karty — chowamy do odświeżenia */ }
        setUkryty(true);
    };

    return (
        <>
            <div className={styles.baner} role="status" data-testid="baner-wygasania-hasla">
                <FiAlertTriangle size={16} aria-hidden="true" className={styles.ikona} />
                <span className={styles.tekst}>
                    {tekstBanera(dni)} Zmień je teraz — po terminie aplikacja wpuści Cię tylko do ekranu zmiany hasła.
                </span>
                <button type="button" className={styles.primaryBtn} onClick={() => setOkno(true)}>Zmień hasło</button>
                <button type="button" className={styles.zamknij} onClick={ukryj} aria-label="Ukryj przypomnienie do końca sesji">
                    <FiX size={16} aria-hidden="true" />
                </button>
            </div>
            <ZmianaHaslaOkno
                isOpen={okno}
                onClose={() => setOkno(false)}
                onZmieniono={() => { if (typeof refreshSession === "function") refreshSession().catch(() => {}); }}
            />
        </>
    );
};

export default BanerWygasaniaHasla;
